// The announcement of the change at the launch (site.config.json launch.at and legal.notice): a small panel at the top
// left of every page while ads are off (build/render.ts renders it only then; turning ads on removes it), with a link to
// the full notice, which stays at its own address. "Don't show again" is kept in this browser per notice id, and the head
// script hides the panel before paint for it; Close hides it for this page view only. A dismissal of an earlier notice
// (the unversioned `chordToMidi.adsNotice=dismissed` of 2026-10-29) hides nothing now.
export const ADS_NOTICE_KEY = 'chordToMidi.adsNotice';

/** Where this browser keeps the dismissal of the notice with this id. */
export function adsNoticeKeyFor(id: string): string {
  return `${ADS_NOTICE_KEY}:${id}`;
}

export function startAdsNotice(): void {
  const panel = document.querySelector<HTMLElement>('.ads-notice');
  if (!panel) return;
  const key = adsNoticeKeyFor(panel.dataset.noticeId ?? '');
  try {
    if (localStorage.getItem(key) === 'dismissed') {
      panel.remove();
      return;
    }
  } catch {
    // Storage unavailable: shown on every page.
  }
  panel.querySelector('[data-ads-notice-close]')?.addEventListener('click', () => panel.remove());
  panel.querySelector('[data-ads-notice-dismiss]')?.addEventListener('click', () => {
    try {
      localStorage.setItem(key, 'dismissed');
    } catch {
      // Not remembered: the panel comes back on the next page.
    }
    panel.remove();
  });
}
